import { render } from "./VSnackbar.vue?vue&type=template&id=1c8061de&scoped=true"
import script from "./VSnackbar.vue?vue&type=script&lang=js"
export * from "./VSnackbar.vue?vue&type=script&lang=js"

import "./VSnackbar.vue?vue&type=style&index=0&id=1c8061de&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src88616841/src/scan_material_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8061de"]])

export default __exports__